import { AxiosRequestConfig } from 'axios';

const absoluteUrlRegex = /^(?:[a-z+]+:)?\/\//i;

export function isRelativeUrl({ url }: AxiosRequestConfig): boolean {
    return url !== undefined && !absoluteUrlRegex.test(url);
}
